
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { BudgetAccountDetailViewModel, BudgetAccountDistributionViewModel, BudgetAccountNoteContext, BudgetAccountNoteViewModel, BudgetAccountSearchCriteria, BudgetAccountViewModel, BudgetAcknowledgmentCriteria, BudgetCodeFiscalContext, ExecutionResult, FiscalDistributionCriteria, IAccountBudget, IAccountBudgetCriteria, IBudgetCodeFiscal, IBudgetFund, IDocument, IFormMetadata, IGroupOption, ISearchCriteria, SearchResult } from "@tylertech/tyler-api-types";

/**
 * BudgetService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class BudgetService {
    constructor(private readonly $apiService: ApiService) { }
    
    AccountSearch(sCriteria: BudgetAccountSearchCriteria): Promise<ExecutionResult<ISearchCriteria<any>>> {
        return this.$apiService.sendAuth("IBudgetService/AccountSearch", sCriteria);
    }
    AutoDistribute(pDist: FiscalDistributionCriteria): Promise<ExecutionResult<BudgetAccountDistributionViewModel[]>> {
        return this.$apiService.sendAuth("IBudgetService/AutoDistribute", pDist);
    }
    DeleteNote(pNote: BudgetAccountNoteViewModel): Promise<ExecutionResult<BudgetAccountNoteViewModel>> {
        return this.$apiService.sendAuth("IBudgetService/DeleteNote", pNote);
    }
    ExportFile(sCriteria: BudgetAccountSearchCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IBudgetService/ExportFile", sCriteria);
    }
    GetAccountBudget(sCriteria: IAccountBudgetCriteria): Promise<IAccountBudget> {
        return this.$apiService.sendAuth("IBudgetService/GetAccountBudget", sCriteria);
    }
    GetAccountDetails(sResult: SearchResult<BudgetAccountDetailViewModel>): Promise<ExecutionResult<SearchResult<BudgetAccountDetailViewModel>>> {
        return this.$apiService.sendAuth("IBudgetService/GetAccountDetails", sResult);
    }
    GetAccountDistribution(sResult: SearchResult<BudgetAccountDistributionViewModel>): Promise<ExecutionResult<SearchResult<BudgetAccountDistributionViewModel>>> {
        return this.$apiService.sendAuth("IBudgetService/GetAccountDistribution", sResult);
    }
    GetAccountNotes(sResult: SearchResult<BudgetAccountNoteViewModel>): Promise<ExecutionResult<SearchResult<BudgetAccountNoteViewModel>>> {
        return this.$apiService.sendAuth("IBudgetService/GetAccountNotes", sResult);
    }
    GetBudgetCodeFiscals(): Promise<ExecutionResult<IBudgetCodeFiscal[]>> {
        return this.$apiService.sendAuth("IBudgetService/GetBudgetCodeFiscals");
    }
    GetControllingBudgetCodeFiscal(): Promise<ExecutionResult<BudgetCodeFiscalContext>> {
        return this.$apiService.sendAuth("IBudgetService/GetControllingBudgetCodeFiscal");
    }
    GetFunds(): Promise<ExecutionResult<IBudgetFund[]>> {
        return this.$apiService.sendAuth("IBudgetService/GetFunds");
    }
    GetGLAccountBudgetDetailTableMetadata(): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IBudgetService/GetGLAccountBudgetDetailTableMetadata");
    }
    GetGroupByOptions(): Promise<ExecutionResult<IGroupOption[]>> {
        return this.$apiService.sendAuth("IBudgetService/GetGroupByOptions");
    }
    GetNotesAndAttachmentCounts(pagedSearchResults: any[]): Promise<any[]> {
        return this.$apiService.sendAuth("IBudgetService/GetNotesAndAttachmentCounts", pagedSearchResults);
    }
    SaveAccountDetails(pAccount: BudgetAccountViewModel): Promise<ExecutionResult<BudgetAccountViewModel>> {
        return this.$apiService.sendAuth("IBudgetService/SaveAccountDetails", pAccount);
    }
    SaveAccountDistribution(pAccount: BudgetAccountViewModel): Promise<ExecutionResult<BudgetAccountViewModel>> {
        return this.$apiService.sendAuth("IBudgetService/SaveAccountDistribution", pAccount);
    }
    SaveBudget(pAccount: BudgetAccountViewModel): Promise<ExecutionResult<BudgetAccountViewModel>> {
        return this.$apiService.sendAuth("IBudgetService/SaveBudget", pAccount);
    }
    SaveNote(pContext: BudgetAccountNoteContext): Promise<ExecutionResult<BudgetAccountViewModel>> {
        return this.$apiService.sendAuth("IBudgetService/SaveNote", pContext);
    }
    SubmitBudgetForReview(pCriteria: BudgetAcknowledgmentCriteria): Promise<string> {
        return this.$apiService.sendAuth("IBudgetService/SubmitBudgetForReview", pCriteria);
    }
}
